import React, { useEffect } from 'react'
import qs from 'qs'
import { useLocation, useHistory } from 'react-router-dom'
import { prismicClient } from './client'

interface PrismicPreviewInterface {
  token: string
  documentId: string
}

export const PrismicPreviewResolver = ({ children }: { children?: React.ReactElement }) => {
  const { search } = useLocation()
  const history = useHistory()

  useEffect(() => {
    const queryString = qs.parse(search.slice(1)) as unknown as PrismicPreviewInterface

    prismicClient.getPreviewResolver(queryString.token, queryString.documentId)
      .resolve((doc) => doc.uid, '/')
      .then(slug => history.push('/'))
  }, [
    history,
    search
  ])

  return children ?? null
}
